import myApp from './modules/my-app.js'
import objects from './modules/objects'
import objectGroups from './modules/objectGroups'
import objectTypes from './modules/object-type'
import positions from './modules/positions'
import roles from './modules/roles'
import objectStatus from './modules/object-status'
import cities from './modules/city'
export default {
    myApp,
    objects,
    objectGroups,
    objectTypes,
    objectStatus,
    positions,
    roles,
    cities
}